import { Injectable } from '@angular/core';
import { CallableNames, DbService } from '../db.service';
import { Currency } from '../../enums/price/currencies.enum';
import { Observable } from 'rxjs';
import { InvoiceFEDocumentType } from '../../models/invoice/invoice-fe.model';

export interface IJobExportData {
  orgId: number;
  month: number;
  year: number;
  userId?: number;
};

export interface ICallablesExportReservationsData {
  reservationIds: number[];
  currency?: Currency;
};

export interface IInvoiceExportData {
  documents: IExportDocumentData[];
  dateFrom?: Date;
  dateTo?: Date;
}

export interface IExportPaymentsData {
  transferIds: number[];
}

export interface IExportDocumentData {
  uuid: string;
  type: InvoiceFEDocumentType;
}

interface ICallablesExportSessionAttendanceData {
  sessionId: number;
}

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor(
    private dbService: DbService,
  ) { }

  public getSessionAttendanceSheet(data: ICallablesExportSessionAttendanceData): Observable<string> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesExportSessionAttendance, data });
    return this.dbService.handleObs(obs, { succSilent: true });
  }

  public getJobReportDownloadLink(data: IJobExportData) {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesExportJobReport, data });
    return this.dbService.handleObs(obs, { succSilent: true });
  }

  public getInvoiceDownloadLink(data: IInvoiceExportData) {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesExportIsdocInvoice, data });
    return this.dbService.handleObs(obs, { succSilent: true });
  }

  public getInvoicesOverviewDownloadLink(data: IInvoiceExportData): Observable<string | null> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesExportInvoicesOverview, data });
    return this.dbService.handleObs(obs, { succSilent: true });
  }

  public getPohodaInvoiceDownloadLink(data: IInvoiceExportData) {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesExportInvoicesPohoda, data });
    return this.dbService.handleObs(obs, { succSilent: true });
  }

  public getMoneyS3InvoiceDownloadLink(data: IInvoiceExportData) {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesExportInvoicesMoneyS3, data });
    return this.dbService.handleObs(obs, { succSilent: true });
  }

  public getPaymentsExportLink(data: IExportPaymentsData) {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesExportPayments, data });
    return this.dbService.handleObs(obs, { succSilent: true });
  }

  public getEventIcsDownloadLing(eventId: number): Observable<string> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesExportEventIcs, data: { eventId } });
    return this.dbService.handleObs(obs);
  }
}
